(function(){
'use strict';
if(window.__elzInit)return;window.__elzInit=true;
var $=function(s,r){return(r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var root=document.documentElement;
var CD='elzaro-cart-drawer';

/* ---------- toast system (window.elzToast) ---------- */
var TI={
  success:'<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-10"/></svg>',
  error:'<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"><path d="M12 6v8M12 18v.01"/></svg>',
  info:'<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"><path d="M12 11v7M12 6v.01"/></svg>'
};
function toastCss(){
  if(document.getElementById('elz-toast-css'))return;
  var s=document.createElement('style');s.id='elz-toast-css';
  s.textContent='.elz-toasts{position:fixed;z-index:300;left:50%;bottom:90px;transform:translateX(-50%);display:flex;flex-direction:column;gap:10px;width:min(92vw,380px);pointer-events:none}@media(min-width:750px){.elz-toasts{left:auto;right:24px;bottom:auto;top:150px;transform:none}}.elz-tst{display:flex;align-items:flex-start;gap:12px;padding:13px 14px;background:#1a1a1a;color:#f8f6f2;border-left:3px solid #c5a059;box-shadow:0 12px 30px rgba(0,0,0,.28);font:500 13px/1.45 var(--elz-body,Montserrat,Arial,sans-serif);pointer-events:auto;animation:elzTin .28s ease both}.elz-tst--error{border-left-color:#e0574f}.elz-tst--info{border-left-color:#8c8577}.elz-tst__i{flex:none;display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#c5a059;color:#1a1a1a}.elz-tst--error .elz-tst__i{background:#e0574f;color:#fff}.elz-tst--info .elz-tst__i{background:#8c8577;color:#fff}.elz-tst__t{flex:1;min-width:0}.elz-tst__t b{display:block;margin-bottom:1px;font-weight:600;letter-spacing:.01em}.elz-tst__t span{color:#d8d1c0;font-weight:400}.elz-tst__x{flex:none;padding:0 2px;border:0;background:none;color:#cfc8b8;font-size:18px;line-height:1;cursor:pointer}.elz-tst.is-out{animation:elzTout .22s ease both}@keyframes elzTin{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}@keyframes elzTout{to{opacity:0;transform:translateX(12px)}}';
  document.head.appendChild(s);
}
function dismiss(n){if(!n||!n.parentNode)return;clearTimeout(n._t);n.classList.add('is-out');setTimeout(function(){if(n.parentNode)n.parentNode.removeChild(n)},220)}
function toast(msg,opts){
  if(typeof opts==='boolean')opts={type:opts?'error':'success'};
  opts=opts||{};var type=opts.type||'success';
  toastCss();
  var box=$('.elz-toasts');
  if(!box){box=document.createElement('div');box.className='elz-toasts';box.setAttribute('role','status');box.setAttribute('aria-live','polite');document.body.appendChild(box)}
  var key=type+'|'+(opts.title||'')+'|'+msg;
  var ex=$$('.elz-tst',box).filter(function(n){return n.dataset.k===key})[0];
  if(ex){clearTimeout(ex._t);ex._t=setTimeout(function(){dismiss(ex)},opts.duration||3400);return}
  var n=document.createElement('div');n.className='elz-tst elz-tst--'+type;n.dataset.k=key;
  n.innerHTML='<span class="elz-tst__i">'+TI[type]+'</span><div class="elz-tst__t">'+(opts.title?'<b></b>':'')+'<span class="m"></span></div><button type="button" class="elz-tst__x" aria-label="Dismiss">&times;</button>';
  if(opts.title)$('b',n).textContent=opts.title;
  $('.m',n).textContent=msg;
  $('.elz-tst__x',n).addEventListener('click',function(){dismiss(n)});
  box.appendChild(n);
  if(box.children.length>3)dismiss(box.children[0]);
  n._t=setTimeout(function(){dismiss(n)},opts.duration||3400);
}
window.elzToast=toast;

/* open/close drawers, search, lightbox */
document.addEventListener('click',function(e){
  var o=e.target.closest('[data-elz-open]');
  if(o){var k=o.getAttribute('data-elz-open');var el=$('[data-elz-'+k+']');if(el){el.classList.add('is-open');root.classList.add('elz-lock');if(k==='search'){var i=$('input',el);if(i)setTimeout(function(){i.focus()},60)}}return}
  var c=e.target.closest('[data-elz-close]');
  if(c){var k2=c.getAttribute('data-elz-close');var el2=$('[data-elz-'+k2+']');if(el2)el2.classList.remove('is-open');root.classList.remove('elz-lock')}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){$$('[data-elz-drawer].is-open,[data-elz-search].is-open,[data-elz-lightbox].is-open,[data-elz-cdrawer].is-open,[data-elz-filters].is-open').forEach(function(x){x.classList.remove('is-open')});root.classList.remove('elz-lock')}});

/* ---------- cart drawer ---------- */
function drawerRender(html){
  var body=$('[data-elz-cbody]');if(!body||!html)return;
  var d=new DOMParser().parseFromString(html,'text/html'),n=$('.elz-cd',d);if(!n)return;
  body.innerHTML=n.outerHTML;
  $$('[data-elz-cart-count]').forEach(function(el){el.textContent=n.dataset.count});
  var t=$('[data-elz-cdtitle]');if(t)t.textContent='Shopping Cart ('+n.dataset.count+')';
}
function drawerOpen(){var c=$('[data-elz-cdrawer]');if(c){c.classList.add('is-open');root.classList.add('elz-lock')}}
function drawerLoad(){return fetch('/?sections='+CD+'&t='+Date.now(),{cache:'no-store'}).then(function(r){return r.json()}).then(function(j){drawerRender(j[CD])})}
function qtyToast(qty,prev,name){
  if(qty===0)toast(name+' was removed from your cart.',{type:'info',title:'Item removed'});
  else if(qty>prev)toast(name+' \u00d7 '+qty,{title:'Quantity increased'});
  else toast(name+' \u00d7 '+qty,{type:'info',title:'Quantity decreased'});
}
function drawerChange(line,qty,prev,name){
  var body=$('[data-elz-cbody]');if(body)body.classList.add('is-busy');
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:line,quantity:qty,sections:CD})})
    .then(function(r){return r.json()})
    .then(function(c){
      if(c.status&&c.message){toast(c.message,{type:'error',title:'Cart not updated'});return drawerLoad()}
      if(c.sections&&c.sections[CD])drawerRender(c.sections[CD]);else return drawerLoad();
      qtyToast(qty,prev,name);
    })
    .catch(function(){toast('Please try again.',{type:'error',title:'Cart not updated'});return drawerLoad()})
    .then(function(){if(body)body.classList.remove('is-busy')});
}
document.addEventListener('click',function(e){
  var a=e.target.closest('#cart-icon-bubble');
  if(a&&$('[data-elz-cdrawer]')&&location.pathname.replace(/\/$/,'')!=='/cart'){e.preventDefault();drawerOpen();drawerLoad();return}
  var b=e.target.closest('[data-cd-qty],[data-cd-remove]');
  if(b){
    var row=b.closest('.elz-cd__item');if(!row)return;
    var i=$('input',row),prev=parseInt(i.value,10)||1,qty=0;
    var nm=($('.elz-cd__t',row)||{}).textContent;nm=(nm||'Item').trim();
    if(!b.hasAttribute('data-cd-remove'))qty=Math.max(0,prev+parseInt(b.dataset.cdQty,10));
    drawerChange(parseInt(row.dataset.line,10),qty,prev,nm);
  }
});
document.addEventListener('change',function(e){
  var i=e.target.closest('[data-cd-input]');
  if(!i)return;
  var row=i.closest('.elz-cd__item'),nm=(($('.elz-cd__t',row)||{}).textContent||'Item').trim();
  var prev=parseInt(i.defaultValue,10)||1,qty=Math.max(0,parseInt(i.value,10)||0);
  drawerChange(parseInt(row.dataset.line,10),qty,prev,nm);
});

/* tabs */
document.addEventListener('click',function(e){
  var t=e.target.closest('.elz-tab');if(!t)return;
  var r=t.closest('[data-elz-tabs]');
  $$('.elz-tab',r).forEach(function(b){b.classList.toggle('is-active',b===t)});
  $$('.elz-panel',r).forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-panel')===t.getAttribute('data-tab'))});
  var v=$('[data-viewall]',r);if(v&&t.dataset.url)v.setAttribute('href',t.dataset.url);
});

/* carousels */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-car]');if(!b)return;
  var tr=$('.elz-car__track',b.closest('[data-elz-car]'));if(!tr)return;
  tr.scrollBy({left:(b.dataset.car==='next'?1:-1)*tr.clientWidth,behavior:'smooth'});
});

/* hero */
function initHero(h){
  if(h.__i)return;h.__i=1;
  var slides=$$('.elz-hero__slide',h),cur=0,timer,speed=parseInt(h.dataset.speed,10)||6000,auto=h.dataset.autoplay==='true';
  var cnt=$('[data-cur]',h),bar=$('.elz-hero__bar i',h);
  function progress(){if(!bar)return;bar.style.transition='none';bar.style.width='0';void bar.offsetWidth;if(auto&&slides.length>1){bar.style.transition='width '+speed+'ms linear';bar.style.width='100%'}}
  function go(i){cur=(i+slides.length)%slides.length;slides.forEach(function(s,k){s.classList.toggle('is-active',k===cur)});if(cnt)cnt.textContent=(cur+1<10?'0':'')+(cur+1);progress()}
  function play(){clearInterval(timer);if(auto&&slides.length>1)timer=setInterval(function(){go(cur+1)},speed)}
  h.addEventListener('click',function(e){var b=e.target.closest('[data-hero]');if(!b)return;go(cur+(b.dataset.hero==='next'?1:-1));play()});
  go(0);play();
}

/* gallery + zoom */
function setActive(pdp,id){
  $$('.elz-gal__slide',pdp).forEach(function(s){s.classList.toggle('is-active',String(s.dataset.mediaId)===String(id))});
  $$('.elz-gal__thumb',pdp).forEach(function(t){t.classList.toggle('is-active',String(t.dataset.mediaId)===String(id))});
}
document.addEventListener('click',function(e){
  var t=e.target.closest('.elz-gal__thumb');
  if(t){setActive(t.closest('[data-elz-pdp]'),t.dataset.mediaId);return}
  var z=e.target.closest('[data-elz-zoombtn]');
  if(z){var img=$('.elz-gal__slide.is-active img',z.closest('[data-elz-pdp]'));var lb=$('[data-elz-lightbox]');if(img&&lb){$('img',lb).src=img.currentSrc||img.src;lb.classList.add('is-open');root.classList.add('elz-lock')}}
});
document.addEventListener('mousemove',function(e){
  var z=e.target.closest&&e.target.closest('[data-elz-zoom]');
  if(!z||!window.matchMedia('(hover:hover)').matches)return;
  var img=$('.elz-gal__slide.is-active img',z);if(!img)return;
  var r=z.getBoundingClientRect();
  img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
  z.classList.add('is-zoom');
});
document.addEventListener('mouseout',function(e){
  var z=e.target.closest&&e.target.closest('[data-elz-zoom]');
  if(z&&!z.contains(e.relatedTarget))z.classList.remove('is-zoom');
});

/* quantity (product page) */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-qty]');if(!b)return;
  var i=$('[data-elz-qty]',b.closest('.elz-qty'));if(!i)return;
  i.value=Math.max(1,(parseInt(i.value,10)||1)+parseInt(b.dataset.qty,10));
});

/* variants */
document.addEventListener('change',function(e){
  var r=e.target.closest('[data-elz-opts] input');if(!r)return;
  var pdp=r.closest('[data-elz-pdp]');
  var variants=JSON.parse($('[data-elz-variants]',pdp).textContent);
  var vals=$$('.elz-opt',pdp).map(function(g){var c=$('input:checked',g);return c?c.value:null});
  var v=variants.filter(function(x){return x.options.every(function(o,i){return o===vals[i]})})[0];
  if(!v){$$('[data-elz-add],[data-elz-buy]',pdp).forEach(function(b){b.disabled=true});toast('This combination is not available.',{type:'error',title:'Unavailable'});return}
  $('[data-elz-id]',pdp).value=v.id;
  history.replaceState(null,'',pdp.dataset.url+'?variant='+v.id);
  if(v.featured_media)setActive(pdp,v.featured_media.id);
  fetch(pdp.dataset.url+'?variant='+v.id+'&section_id='+pdp.dataset.section).then(function(r){return r.text()}).then(function(html){
    var d=new DOMParser().parseFromString(html,'text/html');
    $$('[data-elz-swap]',pdp).forEach(function(el){var n=$('[data-elz-swap="'+el.dataset.elzSwap+'"]',d);if(n)el.innerHTML=n.innerHTML});
  });
});

/* add to cart / buy now */
document.addEventListener('click',function(e){
  var add=e.target.closest('[data-elz-add],[data-elz-buy]');if(!add)return;
  var form=add.closest('form');if(!form||add.disabled)return;
  e.preventDefault();
  var buy=add.hasAttribute('data-elz-buy');
  var err=$('[data-elz-err]',form.parentNode);if(err)err.textContent='';
  var fd=new FormData(form);
  fd.set('quantity',(($('[data-elz-qty]',form)||{}).value)||'1');
  if(!buy)fd.append('sections',CD);
  add.classList.add('is-loading');
  fetch('/cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest',Accept:'application/javascript'},body:fd})
    .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
    .then(function(x){
      if(!x.ok||x.d.status){throw new Error(x.d.description||x.d.message||'Could not add this item to your cart.')}
      if(buy){toast('Taking you to checkout\u2026',{type:'info',title:'Buy it now'});location.href='/checkout';return}
      if(x.d.sections&&x.d.sections[CD]){drawerRender(x.d.sections[CD]);drawerOpen()}
      else{drawerLoad().then(drawerOpen,drawerOpen)}
      toast((x.d.product_title||'Item')+' was added to your cart.',{title:'Added to cart'});
    })
    .catch(function(er){var m=er.message||'Could not add this item to your cart.';if(err)err.textContent=m;toast(m,{type:'error',title:'Could not add to cart'})})
    .then(function(){add.classList.remove('is-loading')});
});
document.addEventListener('click',function(e){if(e.target.closest('[data-elz-stickyadd]')){var a=$('[data-elz-add]');if(a)a.click()}});

/* wishlist (local) */
var WK='elz_wish';
function wl(){try{return JSON.parse(localStorage.getItem(WK)||'[]')}catch(x){return[]}}
function paintWish(){var l=wl();$$('[data-elz-wish-count]').forEach(function(n){n.textContent=l.length});$$('[data-elz-wish]').forEach(function(b){b.classList.toggle('is-on',l.indexOf(b.dataset.elzWish)>-1)})}
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-elz-wish]');if(!b)return;
  var l=wl(),h=b.dataset.elzWish,i=l.indexOf(h);
  if(i>-1)l.splice(i,1);else l.push(h);
  try{localStorage.setItem(WK,JSON.stringify(l))}catch(x){}
  paintWish();
  if(i>-1)toast('Removed from your wishlist.',{type:'info',title:'Wishlist'});else toast('Saved to your wishlist.',{title:'Wishlist'});
});

/* read more, back to top */
document.addEventListener('click',function(e){
  var r=e.target.closest('[data-elz-rm]');
  if(r){var box=r.closest('[data-elz-readmore]');var open=box.classList.toggle('is-open');r.textContent=open?'Read less':'Read more'}
  if(e.target.closest('[data-elz-top]')){window.scrollTo({top:0,behavior:'smooth'})}
});

/* sticky mobile add-to-cart */
function initSticky(){
  var s=$('[data-elz-sticky]'),t=$('.elz-btns');
  if(!s||!t||s.__i||!('IntersectionObserver' in window))return;s.__i=1;
  new IntersectionObserver(function(en){s.classList.toggle('is-on',!en[0].isIntersecting&&en[0].boundingClientRect.top<0)}).observe(t);
}

/* server-rendered form messages (contact, newsletter) and review messages -> toasts */
function scanMessages(){
  $$('.elz-ok:not([data-elz-revmsg]),.elz-news__ok').forEach(function(n){if(n.dataset.t)return;n.dataset.t='1';toast(n.textContent.trim(),{title:'Success'})});
  $$('.elz-err:not([data-elz-revmsg]),.elz-news__err').forEach(function(n){if(n.dataset.t)return;n.dataset.t='1';toast(n.textContent.trim(),{type:'error',title:'Please check the form'})});
}
function watchReviews(){
  if(window.__elzObs||!$('[data-elz-revmsg]'))return;window.__elzObs=true;
  new MutationObserver(function(){
    $$('[data-elz-revmsg]').forEach(function(n){
      var t=n.textContent.trim();
      if(!t){delete n.dataset.t;return}
      if(n.dataset.t===t)return;n.dataset.t=t;
      if(n.classList.contains('elz-err'))toast(t,{type:'error',title:'Review not sent'});else toast(t,{title:'Review submitted'});
    });
  }).observe(document.body,{subtree:true,childList:true,characterData:true});
}

function init(){
  $$('[data-elz-hero]').forEach(initHero);
  initSticky();paintWish();scanMessages();watchReviews();
  $$('[data-elz-readmore]').forEach(function(r){var c=$('.elz-clamp',r),b=$('[data-elz-rm]',r);if(c&&b&&c.scrollHeight<=c.clientHeight+2)b.hidden=true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
